import {
    DOC,
    PNG,
    DOCX,
    CODE_FILE_UNDEFINED_ERROR,
    CODE_FILE_SIZE_ERROR,
    CODE_FILE_TYPE_ERROR,
    GIF,
    JPG,
    PDF,
} from 'constants/file/fileTypes';

export type ItemsType =
    | {
          orderItemId: string;
          prescriptionStatus: string;
      }[]
    | null;
export type FieldType = (DoctorDetailsItemType & BaseItemType) | (FileItemType & BaseItemType);
export type DoctorDetailsType = {
    patientName: string;
    name: string;
    city: string;
    regionCode: string;
    firstName?: string;
    lastName?: string;
    mailingAddress1stLine?: string;
    mailingAddressCity?: string;
    mailingAddressFax?: string;
    mailingAddressPhone?: string;
    mailingAddressState?: string;
    mailingAddressZipCode?: string;
    organizationName?: string;
    email?: string;
    fax?: string;
    phone?: string;
    filling_method?: number;
    location?: number;
};

export type FileSpeciesType =
    | typeof DOC
    | typeof GIF
    | typeof JPG
    | typeof PDF
    | typeof PNG
    | typeof DOCX
    | '';

export type ErrorType =
    | typeof CODE_FILE_UNDEFINED_ERROR
    | typeof CODE_FILE_SIZE_ERROR
    | typeof CODE_FILE_TYPE_ERROR
    | '';

export type DoctorDetailsItemType = {
    doctorDetails: DoctorDetailsType;
    isAutocompleteModeEnabled: boolean;
    type?: 'success' | 'error' | '';
    fileSrc?: string;
    fileName?: string;
    errorType?: ErrorType;
    fileType?: FileSpeciesType;
};
export type FileItemType = {
    type: 'success' | 'error' | '';
    fileSrc: string;
    errorType?: ErrorType;
    fileType: FileSpeciesType;
    fileName: string;
    doctorDetails?: DoctorDetailsType;
};

export type BaseItemType = {
    image: string;
    name: string;
    orderItemId: string;
    sendBy: number;
    isEyeExam?: boolean;
    isVisiblyExam?: boolean;
};
export const FILL_IT = 1;
export const SEND_LATER = 3;
export const UPLOAD = 4;

export const PRESCRIPTION_LOCATION = 2;

export const SUCCESS_PAGE_FIELDS_DEFAULT = {
    fileName: '',
    fileSrc: '',
    image: '',
    location: PRESCRIPTION_LOCATION,
    name: '',
    sendBy: 0,
};

export const SMART_SEARCH_FILLING_METHOD = 2;

export const MANUALLY_FILLING_METHOD = 1;

export type OrderStatusType = {
    isError: boolean;
    isLoading: boolean;
    items: ItemsType;
};
export type VisiblyDetailsType = {
    values: VisiblyType;
    errors: Partial<VisiblyType> & {message?: string};
    examID?: number | null;
    examToken?: string;
};
type VisiblyType = {
    dateOfBirth: string;
    state: string;
};
export type AlgoliaHitMappedType = {
    firstName: string;
    lastName: string;
    mailingAddress1stLine: string;
    mailingAddressCity: string;
    mailingAddressFax: string;
    mailingAddressPhone: string;
    mailingAddressState: string;
    mailingAddressZipCode: string;
    organizationName: string;
    id: string;
};

type AlgoliaHitRsType = {
    'First Name': string;
    'Last Name': string;
    Address: string;
    'Mailing Address City': string;
    'Mailing Address Fax': string;
    'Mailing Address Phone': number;
    'Mailing Address State': string;
    'Mailing Address Zip Code': number;
    'Organization Name': string;
    objectID: string;
};

export type AlgoliaRsType = {
    exhaustiveNbHits: boolean;
    exhaustiveTypo: boolean;
    hits: AlgoliaHitRsType[];
    hitsPerPage: string;
    nbHits: string;
    nbPages: string;
    page: string;
    params: string;
    processingTimeMS: number;
    query: string;
};
